const colorOverrides: Map<string, string> = new Map<string, string>([['brown', '#964B00']]);

export const getColor = (colorName: string): string => {
  return colorOverrides.get(colorName) || colorName;
};
